import { render, staticRenderFns } from "./drawResult.vue?vue&type=template&id=2823344a&scoped=true&"
import script from "./drawResult.vue?vue&type=script&lang=js&"
export * from "./drawResult.vue?vue&type=script&lang=js&"
import style0 from "./drawResult.vue?vue&type=style&index=0&id=2823344a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2823344a",
  null
  
)

export default component.exports